/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Fc_Wins_TitleInputs */

const en_fc_vs_fc_wins_title = /** @type {(inputs: Fc_Vs_Fc_Wins_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where FilmCraft wins`)
};

/**
* | output |
* | --- |
* | "Where FilmCraft wins" |
*
* @param {Fc_Vs_Fc_Wins_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_fc_wins_title = /** @type {((inputs?: Fc_Vs_Fc_Wins_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Fc_Wins_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_fc_wins_title(inputs)
});
export { fc_vs_fc_wins_title as "fc.vs.fc_wins.title" }